import { useEffect, useState } from "react";
import { Box, Grid, Paper, Tab, Tabs, Typography } from "@mui/material";
import { ReceivingPackageResponse } from "../../app/models/responseModels/ReceivingPkgResponse";
import React from "react";

interface LoadScanPackagesProps {
  receivingPkgs: ReceivingPackageResponse[];
  confirmedPkgs: ReceivingPackageResponse[];
  alreadyScannedPkgs: ReceivingPackageResponse[];
}

const LoadScanPackages: React.FC<LoadScanPackagesProps> = ({
  receivingPkgs,
  confirmedPkgs,
  alreadyScannedPkgs,
}) => {
  const [activeView, setActiveView] = useState(1);
  const [alreadyScannedPkgsCount, setAlreadyScannedPkgsCount] = useState(0);
  const [toBeScannedCount, setToBeScannedCount] = useState(0);
  const [confirmedPkgsCount, setConfirmedPkgsCount] = useState(0);

  useEffect(() => {
    setConfirmedPkgsCount(confirmedPkgs.length);
    setToBeScannedCount(
      receivingPkgs.filter((pkg) => !pkg.isLoadScanned).length
    );
    setAlreadyScannedPkgsCount(alreadyScannedPkgs.length);
  }, [receivingPkgs, alreadyScannedPkgs]);

  const handleViewChange = (event: any, newValue: number) => {
    setActiveView(newValue);
  };

  const renderPackageDetails = (pkg: ReceivingPackageResponse) => {
    return (
      <Paper sx={{ width: "100%", padding: 1, mt: 1 }} elevation={2}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
            }}
          >
            <Typography>
              <b>ORDER ID:</b> {pkg.orderId}
            </Typography>
            <Typography>
              <b>SID:</b> {pkg.sid ? pkg.sid.toUpperCase() : null}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "end",
            }}
          >
            <Typography>
              <b>TOTE ID: </b>
              {pkg.toteId}
            </Typography>
            <Typography>
              <b>Drop Number: </b>
              {pkg.dropNumber}
            </Typography>
          </div>
        </div>
      </Paper>
    );
  };

  return (
    <Box sx={{ width: "100%", mb: 0 }}>
      <Tabs value={activeView} onChange={handleViewChange} centered>
        <Tab label={"Scanned (" + alreadyScannedPkgsCount + ")"} />
        <Tab label={"Packages (" + toBeScannedCount + ")"} />
        <Tab label={"Confirmed (" + confirmedPkgsCount + ")"} />
      </Tabs>
      <Grid container sx={{ mt: 1 }}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          sx={{ height: "35vh", overflow: "auto" }}
        >
          {activeView === 0 && (
            <>{alreadyScannedPkgs.map((pkg) => renderPackageDetails(pkg))}</>
          )}
          {activeView === 1 && (
            <>
              {receivingPkgs
                .filter((pkg) => !pkg.isLoadScanned)
                .map((pkg) => renderPackageDetails(pkg))}
            </>
          )}
          {activeView === 2 && (
            <>{confirmedPkgs.map((pkg) => renderPackageDetails(pkg))}</>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default LoadScanPackages;
